// extracted by mini-css-extract-plugin
export var logo = "_je-2";
export var logoWrapper = "_je-1";
export var strip = "_je-0";